import React from "react";

const PreNav = () => {
  return (
    <div className="pre-nav">
      <div className="pre-nav-web">
        <a className="pre-nav-link" href="tel:4089813456">
          <i className="fas fa-phone"></i> Call Now (408)981-3456
        </a>
        <a
          className="pre-nav-link"
          href="sms:4089813456"
          style={{ marginLeft: "2rem" }}
        >
          <i className="fas fa-sms"></i> Text Us (408)981-3456
        </a>
        <a
          className="pre-nav-link"
          href="mailto:info@shotdocmd.com"
          style={{ marginLeft: "2rem" }}
        >
          <i className="fas fa-envelope"></i> Email info@shotdocmd.com
        </a>
      </div>
      <div className="pre-nav-mobile">
        <a className="pre-nav-link" href="tel:4089813456">
          <i className="fas fa-phone"></i> Call Now
        </a>
        <a className="pre-nav-link" href="sms:4089813456">
          <i className="fas fa-sms"></i> Text Now
        </a>
        <a className="pre-nav-link" href="mailto:info@shotdocmd.com">
          <i className="fas fa-envelope"></i> Email Now
        </a>
      </div>
    </div>
  );
};

export default PreNav;
